// extracted by mini-css-extract-plugin
module.exports = {"footer":"PlaysFooter_footer__2FElz","active":"PlaysFooter_active__3P4iH"};